import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ClipBoardService } from '../../../services/clipboard.service';
import { FormGroup,Validators,FormBuilder } from '@angular/forms';
import { ServerService } from 'src/app/services/server.service';
@Component({
    selector: 'appointment-modal',
    templateUrl: './appointment-modal.component.html',
    styleUrls: ['./appointment-modal.component.scss']
})
export class AppointmentModalComponent implements OnInit {
    dataSource: any;
    action = 'exit'
    public dateTime: Date = new Date();
    public min = new Date()
    newRemarkShow: boolean = false;
    clientRemarks: any[] = []
    remarkMandetory: boolean = false;
    newVendorRemark: any = ""
    newClientRemark: any = ""
    vendorRemarks: any[] = []
    leadInfo: any = JSON.parse(localStorage.getItem("leadInfo"))
    vendorRemark: any = "";
    createTaskForm: FormGroup;
    hideTask = true;
    userInfo: any = JSON.parse(localStorage.getItem("userInfo"));
    authToken: string = localStorage.getItem("token");
    constructor(private dialog: MatDialog, public clipBoardService: ClipBoardService,
        private fb:FormBuilder,
        private serverService:ServerService,
        private dialogRef: MatDialogRef<AppointmentModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
    }

    ngOnInit() {
        // this.createTaskForm = this.fb.group({
        //     "task_category": ["", Validators.required],//"Phone",
        //     "subject": ["", Validators.required],//"please call on phone for specific lead",
        //     "priority": ["", Validators.required],//"High",
        //     "description": [""],//"hi every one please send email templates for given lead id Thank you",
        //     "due_date": [new Date()],//"2019-02-10 15:44:37",
        //     "auto_remainder": [false],
        //     "custom_remainder": [new Date()],//"2019-02-09 15:44:37",
        // });
        this.createTaskForm = this.fb.group({
            "task_category": ["Call", Validators.required],//"Phone",
            "subject": ['Reminder - '+ this.leadInfo.project.name +'-' + this.leadInfo.lead_status, Validators.required],//"please call on phone for specific lead",
            "priority": ["1", Validators.required],//"High",
            "description": ["Lead Id:"+ this.leadInfo.id + "\n" + "Name : "+ this.leadInfo.name +  "\n" + "Email:" 
            + this.leadInfo.email  + "\n" + "Phone:"+ this.leadInfo.phone],//"hi every one please send email templates for given lead id Thank you",
            "due_date": [new Date()],//"2019-02-10 15:44:37",
            "auto_remainder": [false],
            "custom_remainder": [new Date()],//"2019-02-09 15:44:37",
        });
        this.dataSource = this.data;
        if (this.data.vendor_appointment_date != null) {
            if (this.data.lead_status != "Appointment Proposed") {
                this.newRemarkShow = true;
            }
            this.dateTime = this.data.vendor_appointment_date;
        }
        // console.log(this.newVendorRemark)
    }

    yes() {
        // debugger;
        // console.log(this.data)
        // console.log("hi")
        if (this.data.vendor_appointment_date == null) {
            if (this.remarkMandetory) {
                this.data.vendor_appointment_date = this.dateTime.toJSON()
                if (this.newVendorRemark.trim() != '') {
                    this.data.vendor_remark = this.newVendorRemark.trim()
                    this.data.vendor_remark_new = this.newVendorRemark.trim();
                    if (this.data.lead_status != "Appointment Proposed") {
                        this.data.lead_status = "V Hold";
                    }
                    this.dialogRef.close(this.data);
                } else {
                    this.clipBoardService.showMessgeInText("Please enter proper Remark", "error-snackbar")
                }
            } else {
                if (this.data.lead_status == "Appointment Proposed") {
                    this.data.vendor_appointment_date = this.dateTime.toJSON()
                }
                if (this.newVendorRemark.trim() != '') {
                    this.data.vendor_remark = this.newVendorRemark.trim()
                    this.data.vendor_remark_new = this.newVendorRemark.trim();
                    this.dialogRef.close(this.data);
                } else {
                    delete this.data.vendor_remark
                    this.dialogRef.close(this.data);
                }
            }
        } else {
            if (this.data.vendor_appointment_date == this.dateTime) {
                this.data.vendor_appointment_date = this.dateTime
            } else {
                this.data.vendor_appointment_date = this.dateTime.toJSON()
            }
            
            if(this.userInfo.member_type == 'Vendor')
            {
                delete this.data.vendor_remark
            this.data.vendor_remark = this.newVendorRemark;
            }
            else if(this.userInfo.member_type =='Client'){
                this.data.client_remark_new  = this.newClientRemark;
                this.data.client_remark = this.newClientRemark;
            }
            // console.log(this.newVendorRemark)
            // console.log(this.data)
            this.dialogRef.close(this.data);
        }
        let body = {
            "task_category": this.createTaskForm.value.task_category,
            "subject": this.createTaskForm.value.subject,
            "priority": this.createTaskForm.value.priority,
            "description": this.createTaskForm.value.description,
            "due_date": this.createTaskForm.value.due_date.toJSON(),//"2019-02-10 15:44:37",
            // "auto_reminder": this.autoReminderNotification,
            "custom_reminder": this.createTaskForm.value.custom_remainder.toJSON(),//"2019-02-09 15:44:37",
            "lead_id": this.leadInfo.id
        }
    
   if(!this.hideTask){
    this.serverService.createLeadTask(body, this.authToken).subscribe(
        data => {
            this.dialogRef.close("Task Created Successfully")
            this.clipBoardService.showMessgeInText("Lead Status Updated Successfully", "success-snackbar")
            // this.saveStatus = false;

        },
        err => {
            this.clipBoardService.checkServerError(err, this.authToken)
            // this.saveStatus = false;
        })
    }
   
    
    
    }

    close() {
        this.dialogRef.close();
    }

    checkAppointment() {
        if (this.data.vendor_appointment_date == null) {
            if (this.dateTime.getTime() > new Date().getTime() + (2 * 60 * 60 * 1000)) {
                this.remarkMandetory = true
            } else {
                this.remarkMandetory = false
            }
        }
    }
    //new feature
    taskModalShow(){
        this.hideTask = !this.hideTask;
    }
}

